import Marquee from "react-fast-marquee";

const PHRASES = [
  "Shopify Experts",
  "Indonesia",
  "Since 2020",
  "Jakarta Studio",
  "Crafted, Not Templated",
  "Built To Sell",
];

export default function EditorialMarquee() {
  return (
    <section className="py-14 md:py-20 border-y border-[var(--border)] bg-[#080808]">
      <Marquee gradient={false} speed={22}>
        <div className="flex items-center pr-8">
          {PHRASES.map((p, i) => (
            <span key={i} className="flex items-center">
              <span className="marquee-text text-[var(--text)] text-5xl md:text-7xl lg:text-8xl whitespace-nowrap px-6">
                {p}
              </span>
              <span className="dot" />
            </span>
          ))}
        </div>
      </Marquee>
    </section>
  );
}
